import { FREE_PRODUCT_ALLOWED_APP_NAMES } from '../constants/index';

// eslint-disable-next-line import/prefer-default-export
export const isAllowedToLoadAppName = appName =>
  typeof appName === 'string'
    ? FREE_PRODUCT_ALLOWED_APP_NAMES.includes(appName.toLowerCase())
    : true;
